import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  standalone: false,
  selector: 'sbnb-suiteop',
  templateUrl: './suiteop.component.html',
  styles: [
    `
      @import 'variables';

      .features {
        border-top: 1px solid $smoke;
        border-bottom: 1px solid $smoke;
        padding: 16px 0;
      }
    `,
  ],
})
export class SuiteopComponent {
  public AppPermission = AppPermission;
  public isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(private readonly deviceDetectionService: DeviceDetectionService) { }
}
